import { HttpContextToken } from '@angular/common/http';

/**
 * @description 로깅을 위한 컨텐츠 토큰입니다.
 * 인터셉터에서 이 토큰을 확인하여 x-log-content 헤더를 추가합니다.
 */
export const LOG_CONTENT = new HttpContextToken<string>(() => '');
